const Twitter = () => (
    <svg
        width='33'
        height='27'
        viewBox='0 0 33 27'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M33 3.20269C31.7864 3.74391 30.4828 4.10959 29.1123 4.27488C30.5264 3.42326 31.5843 2.08292 32.0887 0.50394C30.7601 1.29819 29.3061 1.85726 27.7897 2.15684C26.77 1.06105 25.4194 0.33474 23.9475 0.0906787C22.4756 -0.153382 20.9649 0.0984568 19.6498 0.807097C18.3347 1.51574 17.2889 2.64153 16.6746 4.00969C16.0604 5.37785 15.9122 6.91183 16.2529 8.37347C13.5609 8.23743 10.9273 7.5332 8.52312 6.30649C6.11897 5.07977 3.99796 3.35798 2.29776 1.25286C1.71642 2.26215 1.38215 3.43234 1.38215 4.6786C1.3815 5.80051 1.65601 6.90524 2.18132 7.89477C2.70663 8.8843 3.4665 9.72803 4.39351 10.3511C3.31842 10.3167 2.26706 10.0243 1.32692 9.49832V9.58608C1.32681 11.1596 1.86762 12.6847 2.85757 13.9026C3.84753 15.1205 5.22566 15.9562 6.75813 16.2679C5.76081 16.5395 4.71519 16.5795 3.70026 16.3849C4.13263 17.7388 4.97485 18.9228 6.10901 19.771C7.24317 20.6193 8.61249 21.0893 10.0253 21.1154C7.62699 23.0102 4.66512 24.0381 1.61614 24.0336C1.07604 24.0337 0.536401 24.002 0 23.9385C3.0949 25.9412 6.69758 27.0041 10.377 27C22.8323 27 29.6413 16.6175 29.6413 7.61285C29.6413 7.3203 29.634 7.02483 29.6209 6.73228C30.9454 5.7683 32.0886 4.57459 32.9971 3.20708L33 3.20269Z'
            fill='white'
        />
    </svg>
);

export default Twitter;
